module.exports = __webpack_public_path__ + "static/media/PotatoChips.ee084858.gif";